import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'landing-layout',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LandingLayoutComponent implements OnDestroy, OnInit {
  showHeader = true;
  backgroundColor = 'transparent';
  currentYear = new Date().getFullYear();

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(private router: Router, private route: ActivatedRoute) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.router.events.pipe(
      map(() => this.getCurrentRouteData())
    ).subscribe((data: Data) => {
      this.backgroundColor = data.backgroundColor || 'transparent';
      if ('showHeader' in data) {
        this.showHeader = data?.showHeader;
      } else {
        this.showHeader = true;
      }
    });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  getCurrentRouteData(): Data {
    let route = this.route.firstChild;
    while (route?.firstChild) {
      route = route.firstChild;
    }
    return route?.snapshot.data || {};
  }

}
